import { render, staticRenderFns } from "./PlatformHome.vue?vue&type=template&id=2b1a5b8b"
import script from "./PlatformHome.vue?vue&type=script&lang=js"
export * from "./PlatformHome.vue?vue&type=script&lang=js"
import style0 from "./PlatformHome.vue?vue&type=style&index=0&id=2b1a5b8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports